var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$lds.some(['home', 'cart', 'checkout', 'orderconfirmed', 'productbatch'], (name) => name === _vm.$route?.name?.toLowerCase()))?_c('div',[_c('SideFloatingBar')],1):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }